<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>الايرادات والمصروفات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم عرض جميع الايرادات والمصروفات
                                <div v-show="$per.value.saveRecordRevenueExpenses" class='pull-left' style='padding=0px'>
                                    <button @click='showForm(0)' type='button' class='btn btn-outline btn-primary btn-sm ' style='padding:3px;width: 80px' data-toggle='modal' data-target='#myModal'>
                                      <b>  إضافة جديد </b>
                                    </button>
                                </div>
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                                <ul v-if='mainValidationErrors'>
                                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class="row">
                              <div class='col-lg-4 col-md-4 col-sm-6'>
                                    <label>الفرع</label>
                                    <select class="form-control"  v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>

                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate  :mytitle='fromTitle' v-model= 'date_from' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate  :mytitle='toTitle' v-model= 'date_to' ></tbDate>
                              </div>

                                  <div style="padding-top:25px" class='col-lg-1 col-md-1 col-sm-6'>
                                      <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' style='padding:3px;width: 60px'>
                                        <b> عرض </b>
                                      </button>
                                  </div>
                                  </div>
                                  <br>
                                  <p class="text-success">الاجمالى: {{totalItem}}</p>

                                <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>

                                          <th style='text-align: center'>البيان</th>
                                          <th style='text-align: center'>الأصل</th>
                                          <th style='text-align: center'>الخزينة</th>
                                          <th style='text-align: center'>المبلغ</th>
                                          <th style='text-align: center'>الفترة</th>
                                          <th style='text-align: center'>التاريخ</th>
                                          <th style='text-align: center'>الاجراء</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                        <tr class='odd gradeX' v-for='record in records' :key='record.id'>

                                          <td align='center'>{{record.main}} - {{record.sub}}</td>
                                          <td align='center'> {{record.asset_type }} - {{ record.asset_name }}</td>
                                          <td align='center'>{{record.name}}</td>
                                          <td align='center'>{{record.amount}}</td>
                                          <td align='center'>{{record.period}}</td>
                                          <td align='center'>{{record.date}}</td>
                                          <td align='center'>
                                              <vue-element-loading size='32' :active='isLoadingDelete' spinner='bar-fade-scale' color='#A4A4A4'/>
                                              <button v-show="$per.value.deleteRecordRevenueExpenses" @click='deleteData(record.id)' type='button' class='btn btn-outline btn-danger btn-xs'>حذف</button>
                                              <button v-show="$per.value.editRecordRevenueExpenses" @click='showForm(record)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#myModal'>تعديل</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
                 <div class='modal-dialog  modal-lg'>
                     <div class='modal-content'>
                         <div class='modal-header'>
                             <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                             <h4 class='modal-title' id='myModalLabel'>{{title}}</h4>
                         </div>
                         <form role='form'>
                         <div class='modal-body'>
                           <div class='alert alert-danger alert-dismissable' v-if='errorShow'>
                             <ul v-if='validationErrors'>
                                 <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                             </ul>
                           </div>
                           <div class='alert alert-success alert-dismissable' v-if='successShow'>
                              {{success}}
                           </div>
                           <fieldset>
                                 <input v-model='record.id' name='id' type='text' hidden>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                     <label>الفرع:</label>
                                     <select @change='Gettreasuries($event.target.value);GetAssets ()' class="form-control"  v-model="record.branches_id">
                                       <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                   <label>النوع:</label>
                                   <select @change='changeType()' class="form-control" style="padding: 0px" v-model="record.REtype">
                                     <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                                       {{ type.name }}
                                     </option>
                                   </select>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                     <label>رئيسي:</label>
                                     <select class="form-control" style="padding: 0px" v-model="expenseMainType">
                                       <option v-for="(type,index) in mainType" v-bind:key="index" v-bind:value="type.main">
                                         {{ type.main }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                     <label>فرعى:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.revenue_expense_type_id">
                                       <option v-for="type in RevenueExpenseTypes" v-bind:key="type.id" v-bind:value="type.id">
                                         {{ type.main }} - {{ type.sub }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>نوع الأصل:</label>
                                     <select class="form-control" style="padding: 0px" v-model="asset_type">
                                       <option v-for="item in assetTypes" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-6 col-sm-6'>
                                     <label>اسم الأصل:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.asset_id">
                                       <option v-for="item in AssetName" v-bind:key="item.id" v-bind:value="item.id">
                                         {{ item.asset_type }} - {{ item.asset_name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                     <label>الخزينة:</label>
                                     <select class="form-control" style="padding: 0px" v-model="record.treasury_id">
                                       <option v-for="treasury in treasuries" v-bind:key="treasury.id" v-bind:value="treasury.id">
                                         {{ treasury.name }}
                                       </option>
                                     </select>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                     <label>المبلغ:</label>
                                     <input v-model='record.amount' class='form-control' name='amount' type='text'>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                   <tbDate  :mytitle='monthTitle'  :myformat='month' v-model= 'record.period' ></tbDate>
                                 </div>
                                 <div class='form-group col-lg-3 col-sm-3'>
                                   <tbDate  :mytitle='dateTitle'  v-model= 'record.date' ></tbDate>
                                 </div>
                                 <div class='form-group col-lg-12 col-sm-12'>
                                     <label>ملاحظات:</label>
                                     <input v-model='record.notes' class='form-control' name='notes' type='text'>
                                 </div>
                               </fieldset>
                           </div>
                           <div class='modal-footer'>
                               <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                               <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                               <button @click='saveData' type='button' class='btn btn-primary'>حفظ</button>
                           </div>
                         </form>
                     </div>
                     <!-- /.modal-content -->
                 </div>
                 <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->
             <!-- /.container-fluid -->
        </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'RecordRevenueExpenses',
  data () {
    return {
      month: 'month',
      today: true,
      monthTitle: 'الفترة',
      fromTitle: 'من',
      dateTitle: 'التاريخ',
      toTitle: 'إلى',
      date_from: '',
      date_to: '',
      validationErrors: '',
      mainValidationErrors: '',
      records: {},
      record: {},
      assetTypes: [
        {id: 0, name: ''},
        {id: 1, name: 'أراضى'},
        {id: 2, name: 'مبانى'},
        {id: 3, name: 'سيارات'},
        {id: 4, name: 'موتوسيكلات'},
        {id: 5, name: 'آلات'}
      ],
      asset_type: 0,
      majorExpenses: '',
      majorRevenue: '',
      expenseMainType: '',
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      RevenueExpense: [],
      branche: '',
      treasuries: {},
      branches: {},
      mainType: '',
      types: [{id: 1, name: 'مصروف'}, {id: 0, name: 'إيراد'}],
      emptyRec: [{id: 0, name: ''}],
      title: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.branche = this.branches[0].id
    this.record.branches_id = this.branches[0].id
    this.Gettreasuries(this.record.branches_id)
    this.GetRevenueExpense()
    this.GetAssets()
  },
  computed: {
    RevenueExpenseTypes () {
      if (this.record.REtype === 0) {
        return this.RevenueExpense.filter((RevenueExpense) => RevenueExpense.type === '0' && RevenueExpense.main === this.expenseMainType)
      } else {
        return this.RevenueExpense.filter((RevenueExpense) => RevenueExpense.type === '1' && RevenueExpense.main === this.expenseMainType)
      }
    },
    AssetName () {
      if (this.asset_type > 0) {
        return this.assets.filter((assets) => assets.asset_type_id === this.asset_type)
      }
    },
    totalItem () {
      let total = 0
      if (Object.keys(this.records).length !== 0) {
        this.records.forEach(function (item) {
          total += (parseFloat(item.amount))
        })
      }
      return total
    }
  },
  methods: {
    changeType () {
      if (this.record.REtype === 1) {
        this.mainType = this.majorExpenses
      }
      if (this.record.REtype === 0) {
        this.mainType = this.majorRevenue
      }
    },
    Gettreasuries (id) {
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      let i = this.branches.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.treasuries = this.branches[i].treasuries
      }
    },
    GetRevenueExpense () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getAllMainData', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          this.majorExpenses = data.MajorExpenses
          this.majorRevenue = data.MajorRevenue
          this.RevenueExpense = data.AllSub
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetAssets () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getAssets', {
        token: localStorage.getItem('token'),
        branch_id: this.branches
      })
        .then(({ data }) => {
          this.assets = data
          this.assets.unshift(this.emptyRec)
          this.asset_type = 0
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getRecordRevenueExpenses', {
        token: localStorage.getItem('token'),
        branche: this.branche,
        date_from: this.date_from,
        date_to: this.date_to
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.mainValidationErrors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        let bid = this.record.branches_id
        this.title = 'إضافة سجل جديد'
        this.record = {'id': 0, 'branches_id': bid, 'REtype': 1, 'revenue_expense_type_id': '', 'treasury_id': '', 'amount': '', 'period': '', 'date': '', 'notes': '', 'asset_id': '', 'asset_name': '', 'asset_type': '', 'main': '', 'name': '', 'sub': ''}
        this.changeType()
      } else {
        this.title = 'تعديل بيانات سجل'
        this.record = recID
      }
    },
    saveData () {
      this.isLoadingSave = true
      this.validationErrors = ''
      this.errorShow = false
      axios.post(this.$apiURL + 'saveRecordRevenueExpenses', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        uid: this.record.uid,
        branches_id: this.record.branches_id,
        revenue_expense_type_id: this.record.revenue_expense_type_id,
        treasury_id: this.record.treasury_id,
        amount: this.record.amount,
        period: this.record.period,
        date: this.record.date,
        asset_id: this.record.asset_id,
        notes: this.record.notes
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteRecordRevenueExpenses', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Accounts/RecordRevenueExpenses.vue